import { createSelector } from 'reselect';

export const getGpsAccesor = state => state.stock.gps;

export const gpsSelector = createSelector(getGpsAccesor, state => state);
